import React from 'react'

import WrapperPage from '../containers/WrapperPage'

const withWrapperPage = (Component: React.FC) => {
  return (props: any) => {
    return (
      <WrapperPage
        title="Loading"
        description="Loading"
        isLoading
        Loader={<Component {...props} />}
      />
    )
  }
}

export default withWrapperPage
